import { Outlet } from "react-router-dom";


function PageTestLayout() {
  return (
    <Outlet></Outlet>
  );
}

export default PageTestLayout;